import { ReactNode } from "react";
import { Link } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  to?: string;
  active?: boolean;
}

interface PageLayoutProps {
  title?: string;
  breadcrumbs?: BreadcrumbItem[];
  children: ReactNode;
}

export default function PageLayout({
  title,
  breadcrumbs = [],
  children,
}: PageLayoutProps) {
  return (
    <div className="container-fluid">
      <div className="layout-specing">
        {/* TITLE + BREADCRUMB */}
        <div className="row">
          <div className="col-xl-9 col-md-6">
            {title && <h5 className="mb-0">{title}</h5>}

            {breadcrumbs.length > 0 && (
              <nav aria-label="breadcrumb" className="d-inline-block mt-2">
                <ul className="breadcrumb breadcrumb-muted bg-transparent rounded mb-0 p-0">
                  {breadcrumbs.map((item, idx) => (
                    <li
                      key={idx}
                      className={`breadcrumb-item ${item.active ? "active" : ""}`}
                      aria-current={item.active ? "page" : undefined}
                    >
                      {!item.active && item.to ? (
                        <Link to={item.to}>{item.label}</Link>
                      ) : (
                        item.label
                      )}
                    </li>
                  ))}
                </ul>
              </nav>
            )}
          </div>
        </div>

        {/* PAGE CONTENT */}
        {children}
      </div>
    </div>
  );
}
